const GuestsHover = ({
  children,
  adults,
  handleSelector,
  selector,
  handleAdults,
  handleChildren,
}) => {
  return (
    <div className="w-[32%] flex" onMouseLeave={() => handleSelector()}>
      {selector && (
        <div className="absolute z-40  h-fit  bg-white mt-[-38vh] md:mt-[-61vh] -ml-[11vw] md:ml-[25vw]  rounded-2xl shadow-xl p-6">
          <div className="flex flex-col md:flex-row  md:justify-between ">
            <div className="flex justify-between mx-auto md:mx-0">
              <h4>Adults</h4>
            </div>
            <div className="flex justify-between  scale-[0.9] md:scale-[1]">
              <button
                className="pl-4 pb-1 pr-4 mr-4 ml-4 text-xl text-center text-white rounded cursor-pointer bg-black"
                onClick={() => handleAdults(-1)}
              >
                -
              </button>
              <div>
                <h4 className="font-semibold">{adults}</h4>
              </div>
              <button
                className="pl-4 pb-1 pr-4 mr-4 ml-4 text-xl text-center text-white rounded cursor-pointer bg-black"
                onClick={() => handleAdults(1)}
              >
                +
              </button>
            </div>
          </div>
          <div className="flex flex-col md:flex-row md:justify-between mt-5 ">
            <div className="flex justify-between mx-auto md:mx-0">
              <h4 className="">Children</h4>
            </div>
            <div className="flex justify-between">
              <button
                onClick={() => handleChildren(-1)}
                className="pl-4 pb-1 pr-4 mr-4 ml-4 text-xl text-center text-white rounded cursor-pointer bg-black"
              >
                -
              </button>

              <div>
                <h4 className="font-semibold">{children}</h4>
              </div>

              <button
                onClick={() => handleChildren(1)}
                className="pl-4 pb-1 pr-4 mr-4 ml-4 text-xl text-center text-white rounded cursor-pointer bg-black"
              >
                +
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GuestsHover;
